import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import "./style.scss";
import useIsFirstRender from "../../utils/hooks/useIsFirstRender";

const InternationalPhoneInput = ({ value, onChange, hasError, testid }) => {
  const [defaultCountry] = useState("br");
  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PhoneInput
      disableCountryGuess
      data-testid={testid}
      forceDialCode
      className={`inputPhone ${hasError ? "inputPhone__error" : ""}`}
      defaultCountry={defaultCountry}
      value={value}
      onChange={(phone, { inputValue, country }) => {
        if (isFirstRender.current) return;
        onChange(inputValue, country);
      }}
    />
  );
};

InternationalPhoneInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  testid: PropTypes.string.isRequired,
};

InternationalPhoneInput.defaultProps = {
  value: "",
  hasError: false,
  testid: "",
  onChange: () => {},
};

export default InternationalPhoneInput;
